import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge52 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='推薦者が必要なゴルフ場と不要なゴルフ場' fontWeight={700} />
                <p>
                    「会員からの推薦がなければ入会できない」と会員規約で定めているゴルフ場がある一方、推薦者を必要としないゴルフ場も数多く存在します。まずはご自身が検討しているゴルフ場が推薦者を必要とするかどうかを確認することが第一歩です。
                    <br />
                    推薦人として認められる条件（在籍年数や会員種別など）や推薦状の文例については
                    <a href='/knowledge/18'>推薦状の文例</a>
                    でご紹介しています。本記事では、推薦者が身近にいない場合にどう対応すればよいかを詳しく解説します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='推薦者がいない場合の選択肢' fontWeight={700} />

                <Heading3 title='ゴルフ会員権業者に相談する' />
                <p>
                    ゴルフ会員権業者は、日頃から多数のゴルフ場の会員と接点を持っています。推薦人が見つからず困っている場合は、まず取引実績の豊富な業者に相談してみましょう。ゴルフ場の会員である取引先を紹介してもらえる場合や、推薦者不要の同格クラスのゴルフ場を提案してもらえる場合があります。
                </p>

                <Heading3 title='推薦者不要のゴルフ場を選ぶ' />
                <p>
                    推薦者を必要とせず、書類審査や面接のみで入会できるゴルフ場も多数あります。希望するエリアや予算に近いゴルフ場の中から、入会条件を比較して選ぶのも現実的な方法です。
                </p>

                <Heading3 title='ゴルフ場が指定する紹介制度を利用する' />
                <p>
                    一部のゴルフ場では、面識のある会員がいなくても、ゴルフ場側が窓口となって既存会員を紹介してくれる制度を設けていることがあります。入会を検討しているゴルフ場に直接、あるいは業者を通じて確認してみましょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='推薦者を探す際の注意点' fontWeight={700} />
                <p>
                    面識の薄い相手にいきなり推薦を依頼すると、断られたりトラブルに発展したりすることがあります。推薦人にも印鑑証明書の準備や面接への同伴など相応の負担がかかるため、依頼する際は誠意をもって事情を説明しましょう。
                    <br />
                    無事に推薦を引き受けてもらえた場合の御礼のマナーについては
                    <a href='/knowledge/54'>紹介者へのお礼マナー</a>
                    でご紹介していますので、あわせてご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    推薦者がいない場合でも、ゴルフ会員権業者への相談や推薦者不要のゴルフ場の選択など、入会への道は複数あります。一人で抱え込まず、実績のある業者に早めに相談することが、スムーズな入会への近道です。
                    <br />
                    入会審査そのものに不安がある方は
                    <a href='/knowledge/51'>入会審査に落ちる理由と対策</a>
                    もあわせてご確認ください。
                    <br />
                    ご購入・ご売却の際にはゴルフ会員権の売買実績を有する住地ゴルフにまずはご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge52;
